import Phaser from "phaser";
import { BaseModal } from "@phaser/ui/modals/BaseModal";
import { HomeBtn } from "@phaser/ui/btns/HomeBtn";
import { ResumeBtn } from "@phaser/ui/btns/ResumeBtn";
import type { GameStateController } from "@/phaser/core/game/GameStateController";

export class PauseModal extends BaseModal {
  private panelW: number;
  private panelH: number;

  private titleText!: Phaser.GameObjects.Text;
  private homeBtn!: HomeBtn;
  private resumeBtn!: ResumeBtn;

  constructor(
    scene: Phaser.Scene,
    width: number,
    height: number,
    state: GameStateController,
    onClose?: () => void,
  ) {
    super(scene, { width, height, onClose });

    this.panelW = (width * 681) / 768;
    this.panelH = (height * 486) / 1366;

    this.buildUI(width, height, state);
    this.setDepth(9999);
  }

  private buildUI(width: number, height: number, state: GameStateController) {
    // 패널
    const panel = this.scene.add
      .image(width / 2, height / 2, "s-modal-bg")
      .setDisplaySize(this.panelW, this.panelH)
      .setOrigin(0.5);

    this.titleText = this.scene.add
      .text(width / 2, height / 2 - this.panelH * 0.3, "PAUSED", {
        fontFamily: "Luckiest Guy, Arial",
        fontSize: "100px",
        color: "#1C120E",
        align: "center",
      })
      .setOrigin(0.5);

    this.homeBtn = new HomeBtn(
      this.scene,
      width / 2 - this.panelW * 0.23,
      height / 2 + this.panelH * 0.17,
      () => {
        state.emitExitHome();
      },
    );

    this.resumeBtn = new ResumeBtn(
      this.scene,
      width / 2 + this.panelW * 0.23,
      height / 2 + this.panelH * 0.17,
      () => {
        state.resume();
      },
    );

    this.add([panel, this.titleText, this.homeBtn, this.resumeBtn]);
  }
}
